import LocalStorageService from 'web-app/services/local-storage';
/**
 * Core translates its errors into the locale a request names, else into the kiosk device account's. `setLocale`
 * stores the site's in core's own form, which keeps `de_CH` where i18next, lacking it, would say `de-DE`.
 */
export const withKioskLocale = (url, fetchOptions) => fetcher => {
    const locale = LocalStorageService.getFromLocalStorage('locale');
    if (typeof locale === 'string' && locale !== '') {
        url.searchParams.set('locale', locale);
    }
    return fetcher(url, fetchOptions);
};
